module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('h1', [_vm._v("Users")]), _vm._v(" "), [_c('v-card', [_c('v-card-title', [_vm._v("\n      All Registered Users\n      "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "loading": _vm.loading,
      "item-key": "name",
      "select-all": "",
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],
            on: {
              "click": function($event) {
                _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("arrow_upward")]), _vm._v("\n          " + _vm._s(header.text) + "\n        ")], 1)
        }))]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.firstName) + " " + _vm._s(props.item.lastName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.telephone))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.postcode))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(!props.item.approved) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "ripple": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.approveUser(props.item, props.item.approved)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("block")])], 1) : _vm._e(), _vm._v(" "), (props.item.approved) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "ripple": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.approveUser(props.item, props.item.approved)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("block")])], 1) : _vm._e()], 1)])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "color": "blue",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1)]], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ccd93c3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserList.vue
// module id = 360
// module chunks = 4